import { MESSAGE } from '@vindr/services/constants/message.constant';
import { uniqBy } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

function useRoleMemo({ required, rules, disabled }) {
  const { t } = useTranslation('Vindoc');

  return useMemo(() => {
    const rulesState = [];

    if (required && !disabled)
      rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return uniqBy(rulesState, (rule) => rule?.message);
  }, [t, required, rules, disabled]);
}

export default useRoleMemo;
